import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AdminUsersListLayer from "../components/AdminUserList";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Users " />

        {/* UsersListLayer */}
        <AdminUsersListLayer />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
